import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { connect, } from 'react-redux';
import reduxMount from 'utils/reduxMounter';
import { MOUNT_POINTS, } from 'config/preRenderedSelectorsConfig';
import { jwplayerReducer, isInitializedSelector, STATE_KEY, sdkLoadingStateSelector, } from './jwplayerReducer';
import * as jwplayerActions from './jwplayerActions';
import { t } from 'providers/i18nProvider/i18nProvider';
import { external as externalScriptLoader, } from 'utils/script';
import { jwplayer, } from 'config/externalScripts';
import { randId } from 'utils/string';
import { queryString, } from 'utils/window';
import { withParentAttributesAsProps } from 'utils/reactUtils';
import './jwplayerStyles.scss';




class JwPlayerContainerComponent extends Component {

  constructor(props){
    super(props);
    this.id = `ID${randId()}`;
    this.initPlayer = this.initPlayer.bind(this);
    this.setupAnalytics = this.setupAnalytics.bind(this);
  }

  componentWillMount(){
    const { init, sdkLoadingState, loadSdk, sdkLoaded } = this.props;
    this.dataset = ReactDOM.findDOMNode(this).parentNode.dataset;
    if (!init && !sdkLoadingState){
      loadSdk();
      externalScriptLoader.load({
        name: jwplayer.name
      })(sdkLoaded);
    }
  }

  initPlayer(playerRef){
    const player = window.jwplayer(ReactDOM.findDOMNode(playerRef));
    const { video_id, file_url, thumbnail: image } = this.dataset;
    player.setup({
      file: file_url,
      mediaId: video_id,
      image
    });

    player.on('ready',()=>{
      if (queryString.jwAutoplay){
        player.play();
      }
    })
    this.setupAnalytics(player, video_id);
  }

  setupAnalytics(player, videoId){
    player.on('play', this.props.jwplayerAnalyticsPlayAction.bind(null, videoId));
    player.on('complete', this.props.jwplayerAnalyticsCompleteAction.bind(null, videoId));
    player.on('pause', this.props.jwplayerAnalyticsPauseAction.bind(null, videoId));
    player.on('bufferChange', this.props.jwplayerAnalyticsBufferChangeAction.bind(null, videoId));
    player.on('error', this.props.jwplayerAnalyticsErrorAction.bind(null, videoId));
  }

  render(){
    return this.props.init ?
      <div id={ this.id } ref={ this.initPlayer }/>
     : false;
  }
}

const COMPONENT_NAME = "jwplayerContainer";



function mapStateToProps(state){
  return {
    init: isInitializedSelector(state),
    sdkLoadingState: sdkLoadingStateSelector(state),
  }
}



const jwPlayerContainer = {
  name: COMPONENT_NAME,
  stateKey: STATE_KEY,
  component: connect(mapStateToProps, jwplayerActions)(withParentAttributesAsProps(JwPlayerContainerComponent)),
  reducer: jwplayerReducer
};

function shouldMount(){
  return true;
}

export default function initJwPlayers(){
  if (!shouldMount()) {
    return;
  }
  reduxMount({
    [MOUNT_POINTS.JWPLAYER_BODY]: jwPlayerContainer
  });
}


// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/jwplayer/jwplayerContainer.js